import { z } from "zod";

const id = z
  .string()
  .min(1)
  .max(100)
  .regex(/^[a-zA-Z0-9_-]+$/);
export const zStoryResponseSource = z.enum(["suggestion", "custom"]);
export type StoryResponseSource = z.infer<typeof zStoryResponseSource>;

/** Private authoring provenance. Submitted text is source material, not automatically performed dialogue. */
export const zStoryResponseInput = z
  .object({
    source: zStoryResponseSource,
    text: z
      .string()
      .min(1)
      .max(2000)
      .refine((text) => !!text.trim(), "A response cannot be blank."),
    sourceSceneId: id,
    sourceBeatId: id,
    responseRole: z
      .discriminatedUnion("kind", [
        z.object({ kind: z.literal("audience") }).strict(),
        z.object({ kind: z.literal("character"), characterId: id }).strict(),
      ])
      .optional(),
    /** Ordinary beats which perform the authored selection or its concise character adaptation. */
    performedBeatIds: z.array(id).max(32).default([]),
  })
  .strict();
export type StoryResponseInput = z.infer<typeof zStoryResponseInput>;
